import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    currentTown: {
      lat: 20.523697,
      long: -99.893460
    },
    userPosition: {
      longitude: 100,
    }
    
  },
  mutations: {
    changeCurrentTown(state, town) {
      state.currentTown = town;
    },
    changeUserPosition(state, position){
      state.userPosition = position;
    }
  },
  actions: {
  },
  modules: {
  }
})
